import { NgModule } from '@angular/core';
import {authGuard} from "./guard/auth/auth.guard";
import {guestGuard} from "./guard/guest/guest.guard";
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import {WelcomePage} from "./pages/welcome/welcome.page";
import {LoginPage} from "./pages/login/login.page";
import {ReminderPage} from "./pages/reminder/reminder.page";
import {EmailReminderPage} from "./pages/email-reminder/email-reminder.page";
import {RegistrationPage} from "./pages/registration/registration.page";
import {TabsPage} from "./tabs/tabs.page";

export const routes: Routes = [
  {path: '', component: WelcomePage, canActivate:[guestGuard]},
  {path: 'welcome', component: WelcomePage, canActivate:[guestGuard]},
  {path: 'login', component:LoginPage, canActivate:[guestGuard]},
  {path: 'reminder', component: ReminderPage, canActivate:[guestGuard]},
  {path: 'email-reminder', component: EmailReminderPage, canActivate:[guestGuard]},
  {path: 'registration', component: RegistrationPage, canActivate:[guestGuard]},
  // The web app's page lives under the Help tab (tabs/about/pwa); this keeps the short address working.
  {path: 'pwa', redirectTo: 'tabs/about/pwa', pathMatch: 'full'},
  {path: 'tabs', loadChildren: () => import('./tabs/tabs.routes').then(m => m.TabsPageRoutingModule)},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
// @ts-ignore
export class AppRoutes {}
